(() => {
  'use strict';
  if (customElements.get('ws-ski-slideshow')) return;
  class SkiSlideshow extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (this.slides.length < 2) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.index = 0;
      this.interval = Math.max(2000, Math.min(8000, Number(this.dataset.interval) || 2500));
      this.visible = false;
      this.hovered = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.querySelector('.ws-ski-controls').hidden = false;
      this.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-slide-to]');
        if (dot) { this.paused = true; this.show(Number(dot.dataset.slideTo)); }
        const step = event.target.closest('[data-slide-step]');
        if (step) { this.paused = true; this.show(this.index + Number(step.dataset.slideStep)); }
        if (event.target.closest('[data-slideshow-toggle]')) this.paused = !this.paused;
        this.schedule();
      }, options);
      let startX = null;
      const frames = this.querySelector('.ws-ski-frames');
      frames.addEventListener('touchstart', event => { startX = event.touches[0]?.clientX ?? null; }, { passive: true, ...options });
      frames.addEventListener('touchend', event => {
        if (startX === null) return;
        const delta = (event.changedTouches[0]?.clientX ?? startX) - startX;
        startX = null;
        if (Math.abs(delta) > 45) { this.paused = true; this.show(this.index + (delta < 0 ? 1 : -1)); this.schedule(); }
      }, { passive: true, ...options });
      this.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.paused = true; this.schedule(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => { this.paused = this.motion.matches || this.dataset.autoplay !== 'true'; this.schedule(); }, options);
      this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; this.schedule(); }, { threshold: 0.15 });
      this.observer.observe(this);
      this.show(0);
      this.schedule();
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.index);
        slide.setAttribute('aria-hidden', String(i !== this.index));
      });
      this.querySelectorAll('[data-slide-to]').forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      this.querySelectorAll('.ws-ski-progress span').forEach((bar, i) => bar.classList.toggle('is-current', i === this.index));
      this.querySelector('[data-slide-counter]').textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(this.slides.length).padStart(2, '0')}`;
    }
    schedule() {
      clearTimeout(this.timer);
      const toggle = this.querySelector('[data-slideshow-toggle]');
      toggle.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
      this.querySelector('[data-play-label]').textContent = this.paused ? 'Play' : 'Pause';
      this.querySelector('[data-play-icon]').textContent = this.paused ? '▶' : 'Ⅱ';
      if (!this.paused && !this.hovered && this.visible && !document.hidden) {
        this.timer = setTimeout(() => { this.show(this.index + 1); this.schedule(); }, this.interval);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
  }
  customElements.define('ws-ski-slideshow', SkiSlideshow);
})();
